import { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  IconButton,
  useDisclosure,
} from "@chakra-ui/react";
import { CollecticonTrashBin } from "@devseed-ui/collecticons-chakra";
import { useDeleteScene } from "../../../hooks";


const DeleteSceneButton = () => {
  const { sceneId } = useParams();
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const cancelRef = useRef<HTMLButtonElement>(null);

  const { isPending, isSuccess, error, deleteScene } = useDeleteScene(sceneId);

  return (
    <>
      <IconButton
        display="inline-flex"
        size="sm"
        variant="ghost"
        colorScheme="red"
        color="red.500"
        aria-label="Delete Scene"
        onClick={onOpen}
        title="Delete Scene"
        icon={<CollecticonTrashBin />}
      />
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            {!error && !isSuccess && (
              <>
                <AlertDialogHeader fontSize="lg" fontWeight="semibold">
                  Delete Scene?
                </AlertDialogHeader>
                <AlertDialogBody>
                  By choosing to delete this scene, all the scene information will be removed from
                  the database, as well as its detections, model runs and uploaded files.
                </AlertDialogBody>
                <AlertDialogFooter>
                  <Button isDisabled={isPending} variant="base-text" ref={cancelRef} onClick={onClose}>
                    No
                  </Button>
                  <Button
                    isLoading={isPending}
                    loadingText="Deleting"
                    variant="solid"
                    colorScheme="red"
                    onClick={deleteScene}
                    ml={3}
                  >
                    Yes, delete scene
                  </Button>
                </AlertDialogFooter>
              </>
            )}
            {error && (
              <>
                <AlertDialogHeader fontSize="lg" fontWeight="semibold">
                  Error
                </AlertDialogHeader>
                <AlertDialogBody>{error.message}</AlertDialogBody>
                <AlertDialogFooter>
                  <Button variant="base-outline" ref={cancelRef} onClick={onClose}>
                    Close
                  </Button>
                </AlertDialogFooter>
              </>
            )}
            {isSuccess && (
              <>
                <AlertDialogHeader fontSize="lg" fontWeight="semibold">
                  Success
                </AlertDialogHeader>
                <AlertDialogBody>
                  Scene deleted successfully.
                </AlertDialogBody>
                <AlertDialogFooter>
                  <Button variant="base-outline" ref={cancelRef} onClick={() => navigate("/scenes")}>
                    Close
                  </Button>
                </AlertDialogFooter>
              </>
            )}
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default DeleteSceneButton;
